// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__LD9vf","errors":"Errors_errors__30SM6"};